"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Icon_1 = require("../../Icon");
var Utilities_1 = require("../../Utilities");
var getClassNames = Utilities_1.classNamesFunction();
exports.CheckBase = function (props) {
    var _a = props.checked, checked = _a === void 0 ? false : _a, className = props.className, theme = props.theme, styles = props.styles, useFastIcons = props.useFastIcons;
    var classNames = getClassNames(styles, { theme: theme, className: className, checked: checked, useGlobalCheckHostClass: useFastIcons });
    var IconComponent = useFastIcons ? Icon_1.FontIcon : Icon_1.Icon;
    return (React.createElement("div", { className: classNames.root },
        React.createElement(IconComponent, { iconName: "CircleRing", className: classNames.circle }),
        React.createElement(IconComponent, { iconName: "StatusCircleCheckmark", className: classNames.check })));
};
//# sourceMappingURL=Check.base.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Check/Check.base.js
// module id = 760
// module chunks = 0